import { render, staticRenderFns } from "./strategyTag.vue?vue&type=template&id=17c1a3d4&scoped=true&"
import script from "./strategyTag.vue?vue&type=script&lang=ts&"
export * from "./strategyTag.vue?vue&type=script&lang=ts&"
import style0 from "./strategyTag.vue?vue&type=style&index=0&id=17c1a3d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c1a3d4",
  null
  
)

export default component.exports